<template>
  <div class="footer">
    <div class="footer-top">
      <div class="footer-top-code">
        <div class="code">
          <img :src="QR" />
        </div>
        <span class="code-desc">
          马上关注安易信
        </span>
      </div>
      <div class="footer-top-logo">
        <div class="logo">
          <img :src="LOGO" />
        </div>
        <div class="logo-desc">
          <span>值得信赖的专业数据中心技术服务提供商</span>
          <span>浙江省杭州市祥园路 88 号中国智慧信息产业园 H 幢 403</span>
          <span>TEL: 0571-86086995</span>
        </div>
      </div>
      <div class="footer-top-info">
        <div class="info">
          <span class="info-name">
            服务体系
          </span>
          <div class="info-desc can-link">
            <span v-for="(help, i) in helps" :key="i" @click="handleClick('help' + (i + 1))">{{help.name}}</span>
          </div>
        </div>
      </div>
      <div class="footer-top-info">
        <div class="info">
          <span class="info-name">
            产品
          </span>
          <div class="info-desc can-link">
            <span v-for="(product, i) in products" :key="i" @click="handleClick('introduction' + (i + 1))">{{product.name}}</span>
          </div>
        </div>
      </div>
      <div class="footer-top-info">
        <div class="info">
          <span class="info-name">
            方案
          </span>
          <div class="info-desc can-link">
            <span @click="handleClick('solution1')">医共体数据中心解决方案</span>
            <span v-for="(item, i) in solution" :key="i" @click="handleClick('solution' + (i + 2))">{{item.name}}</span>
            <span @click="handleClick('solution' + (solution.length + 2))">PACS影像混合云方案</span>
            <span @click="handleClick('solution' + (solution.length + 3))">等保解决方案</span>
          </div>
        </div>
      </div>
      <div class="footer-top-other">
        <div class="other">
          <span :style="{ cursor: 'pointer' }" @click="open()">浙ICP备 2020038906 号</span>
          <span>浙江安易信 2015-2020</span>
          <span>本网站源代码及其中所展示之案例</span>
          <span>均属于浙江安易信科技有限公司</span>
          <span>保留所有权利</span>
        </div>
      </div>
    </div>
    <div class="footer-center">
    </div>
  </div>
</template>

<script>
import LOGO from '../assets/images/logo.png'
import QR from '../assets/images/qr.jpeg'
export default {
  data () {
    return {
      LOGO,
      QR
    }
  },

  props: {
    helps: {
      type: Array,
      required: true
    },
    products: {
      type: Array,
      required: true
    },
    solution: {
      type: Array,
      required: true
    }
  },

  methods: {
    handleClick (href) {
      this.$router.push(href)
    },
    open () {
      window.open('https://beian.miit.gov.cn/')
    }
  }
}
</script>

<style lang="less" scoped>
.footer {
  margin-top: 20px;
  background-color: #2c2c2c;
  // height: 250px;
  color: #515151;
  padding: 40px 0px;

  &-top {
    padding-top: 40px;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    &-code {
      display: flex;
      flex-direction: column;
      align-items: center;
      .code {
        width: 65px;
        height: 65px;
        background: #fff;

        img {
          width: 100%;
          height: 100%;
        }
      }
      .code-desc {
        margin-top: 8px;
        font-size: 9px;
      }
    }

    &-logo {
      margin-left: 40px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .logo {
        img {
          width: 93px;
          height: 17.5px;
        }
      }
      .logo-desc {
        margin-top: 8px;
        display: flex;
        flex-direction: column;
        font-size: 9px;
        align-items: flex-start;
        span {
          padding: 4px 0px;
        }
      }
    }

    &-info {
      margin-left: 40px;

      .info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        &-name {
          font-size: 16px;
        }

        &-desc {
          margin-top: 8px;
          display: flex;
          flex-direction: column;
          font-size: 9px;
          align-items: flex-start;
          span {
            padding: 4px 0px;
          }
        }
      }
    }

    &-other {
      margin-left: 40px;
      .other {
        display: flex;
        flex-direction: column;
        font-size: 9px;
        align-items: flex-start;
      }
    }
  }

  &-bottom {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 40px 80px;

    &-desc {
      font-size: 9px;
      span {
        &:after {
          content: ' ';
          display: inline-block;
          width: 1px;
          height: 10px;
          background: #515151;
          margin: 0 4px;
        }
      }
    }
  }

  .can-link {
    span {
      cursor: pointer;
    }
    span:hover {
      text-decoration: underline;
    }
  }
}
</style>